import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faRightFromBracket,
  IconDefinition,
} from '@fortawesome/pro-solid-svg-icons';
import { NavigationItem } from '@lyceo/homi-dashboard/shared/util-models';

@Component({
  selector: 'homi-navigation-bar',
  imports: [FontAwesomeModule],
  templateUrl: './navigation-bar.component.html',
  styleUrl: './navigation-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationBarComponent {
  public readonly navItems: InputSignal<NavigationItem[]> = input<
    NavigationItem[]
  >([]);
  public readonly user: InputSignal<string | undefined> = input();

  public readonly logout: OutputEmitterRef<void> = output<void>();

  public readonly faRightFromBracket: IconDefinition = faRightFromBracket;
}
